module.exports = __webpack_public_path__ + "img/流量.6571ae8c.png";